import {cs} from "../../../../../react/chain-services";
import {UseState} from "../../../../../react/use-state";
import {Types} from "../../../../../types";

export const Pagination = <RowType,>({_key, rows, pageSize=10, next}:{
    _key     ?: React.Key,
    next      : (value:Types.Common.UiComponents.Heavy.Common.Design2.DataTable.Pagination.Next<RowType>) => JSX.Element
    pageSize ?: number,
    rows      : RowType[],
}):JSX.Element => cs(
    ["state", (_, next) => UseState({
        next,
        _key: JSON.stringify({
            _key,
            pageSize,
            // rowsLength: rows?.length ?? 0,
        }),
    })],
    ({state}) => {

        const pageCount = Math.ceil((rows?.length ?? 0) / pageSize);
        const page = Math.min(state.value ?? 0, pageCount - 1);

        return next({
            active: rows && rows.length > pageSize,
            getDisplayedRows: () => rows?.slice(page * pageSize, (page + 1) * pageSize),
            state: {
                ...state,
                value: page,
            },
            pageCount,
        });
    },
);
